(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ivy-emoji-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ivy-emoji-gallery')) {
    class IvyEmojiGallery extends HTMLElement {
      connectedCallback() {
        this.jsonUrl = this.dataset.jsonUrl;
        this.jsonUrlFallback = this.dataset.jsonUrlFallback;
        if (!this.jsonUrl) return;

        this.container = this.querySelector('.ivy-emoji-gallery__categories');
        this.loading = this.querySelector('.ivy-emoji-gallery__loading');

        this.addEventListener('contextmenu', (e) => e.preventDefault());

        this.fetchAndRender();
      }

      async loadJson(url) {
        const resp = await fetch(url);
        if (!resp.ok) throw new Error('HTTP ' + resp.status);
        return resp.json();
      }

      async fetchAndRender() {
        try {
          let data;
          try {
            data = await this.loadJson(this.jsonUrl);
          } catch (primaryErr) {
            if (!this.jsonUrlFallback || this.jsonUrlFallback === this.jsonUrl) throw primaryErr;
            console.warn('[IvyEmojiGallery] Locale JSON unavailable, falling back to English:', primaryErr);
            data = await this.loadJson(this.jsonUrlFallback);
          }
          this.render(data);
        } catch (err) {
          console.error('[IvyEmojiGallery] Failed to load:', err);
          this.loading.innerHTML = '<p style="color:#c00;font-size:14px;">Failed to load emoji data: ' + err.message + '</p>';
        }
      }

      render(categories) {
        this.loading.hidden = true;

        const fragment = document.createDocumentFragment();

        categories.forEach((cat) => {
          const section = document.createElement('div');
          section.className = 'ivy-emoji-gallery__section';

          const title = document.createElement('h3');
          title.className = 'ivy-emoji-gallery__category-title';
          title.textContent = cat['category'] || '';
          section.appendChild(title);

          const grid = document.createElement('div');
          grid.className = 'ivy-emoji-gallery__grid';

          (cat['emojis'] || []).forEach((entry) => {
            const url = entry['url'] || '';
            const desc = entry['text'] || '';

            const wrapper = document.createElement('div');
            wrapper.className = 'ivy-emoji-gallery__item';

            const card = document.createElement('div');
            card.className = 'ivy-emoji-gallery__card';
            card.innerHTML = '<img class="ivy-emoji-gallery__card-img" src="' + url + '" alt="' + desc.replace(/"/g, '&quot;') + '" loading="lazy">';

            const labelEl = document.createElement('div');
            labelEl.className = 'ivy-emoji-gallery__card-label';
            labelEl.textContent = desc.replace(/\n/g, ' ');

            wrapper.appendChild(card);
            wrapper.appendChild(labelEl);
            grid.appendChild(wrapper);
          });

          section.appendChild(grid);
          fragment.appendChild(section);
        });

        this.container.appendChild(fragment);
      }
    }

    customElements.define('ivy-emoji-gallery', IvyEmojiGallery);
  }

  } catch(e) { console.error(e); }
})();
})();
